import { get, set } from 'lodash';

export const TEST_HARNESS_MODULES = {
  APPOINTMENTS: 'APPOINTMENTS'
};

export const APPT_TEST_LABELS = {
  appointments: 'appointments',
  slots: 'slots',
  spawnCreateAppointmentModal: 'spawnCreateAppointmentModal',
  spawnEditAppointment: 'spawnEditAppointment',
  setAppointmentConfirmed: 'setAppointmentConfirmed',
  setAppointmentArrived: 'setAppointmentArrived',
  setAppointmentLate: 'setAppointmentLate',
  checkoutAppointment: 'checkoutAppointment'
} as const;

export const SetupTestHarness = (
  module: string,
  label: string,
  value: Parameters<typeof set>[2]
) => {
  if (module === TEST_HARNESS_MODULES.APPOINTMENTS) {
    if (!(label in APPT_TEST_LABELS)) {
      throw new Error(`Invalid label ${label} for appointments test harness`);
    }
    if (!get(window, 'APPT_TEST_HARNESS')) {
      set(window, 'APPT_TEST_HARNESS', {
        appointments: [],
        slots: [],
        spawnCreateAppointmentModal: () => {},
        spawnEditAppointment: (id: number) => id,
        setAppointmentConfirmed: (id: number) => {
          alert('not implemented yet');
          return id;
        },
        setAppointmentArrived: (id: number) => {
          alert('not implemented yet');
          return id;
        },
        setAppointmentLate: (id: number) => {
          alert('not implemented yet');
          return id;
        },
        checkoutAppointment: (id: number) => {
          alert('not implemented yet');
          return id;
        }
      });
    }
    set(window, `APPT_TEST_HARNESS[${label}]`, value);
  }
};
